<template>
    <div class="container-table">
      <div class="btn-box">
        <div class="left-box">
          <div v-if="tableTitle || tableTitle">
            <span v-if="tableTitle" class="table-title">{{tableTitle}}</span>
            <span v-if="tableSubTitle" class="table-title">{{tableSubTitle}}</span>
          </div>
          <Search v-if="isSearch" @onSearch="onSearch" />
        </div>
        <Btns :form.sync="getBtnsData" @onBtns="onBtns" />
      </div>
      <el-table
        v-loading="newIsLoading"
        :data="getNewTableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @cell-mouse-enter="cellMouseEnter"
        @row-click="rowClick"
      >
        <el-table-column
          v-if="selection"
          type="selection"
          width="55"
          fixed="left">
        </el-table-column>
        <el-table-column
          v-if="isOrder"
          prop="orderNumberUp"
          label="序号"
          width="55"
          fixed="left"
        />
        <template v-for="(item,index) in tableHead">
          <el-table-column
            v-if="item.prop === 'operation'"
            :key="index"
            v-bind="item"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.operation">
                <el-link
                  style="margin-right: 10px"
                  type="primary"
                  v-for="(item1, index1) in scope.row.operation.slice(0, 3)"
                  :key="`item1` + index1"
                  @click="onBtns(item1, scope.row)"
                >
                  {{item1.value}}
                </el-link>
                <el-dropdown v-if="scope.row.operation.slice(3) && scope.row.operation.slice(3).length>0" @command="onBtns">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item2,index2) in scope.row.operation.slice(3)"
                      :key="`item2`+ index2"
                      :command="item2"
                    >{{item2.value}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            v-bind="item"
          >
          </el-table-column>
        </template>
      </el-table>
      <div v-if="isPage"
        class="pages">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="newPagination.currentPage"
          :page-size="newPagination.pageSize"
          :total="newPagination.total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
</template>

<script>
import Search from './components/search'
import Btns from './components/btns'
export default {
  name: 'im-table',
  components: {
    Search,
    Btns
  },
  props: {
    // 表格标题
    tableTitle: {
      type: String,
      default: ''
    },
    // 表格副标题
    tableSubTitle: {
      type: String,
      default: ''
    },
    // 是否加载
    isLoading: {
      type: Boolean,
      default: false
    },
    // 是否搜索
    isSearch: {
      type: Boolean,
      default: false
    },
    // 是否支持多选
    selection: {
      type: Boolean,
      default: false
    },
    // 是否有序号
    isOrder: {
      type: Boolean,
      default: false
    },
    // 是否删除
    isDelete: {
      type: Boolean,
      default: false
    },
    // 是否复制
    isCopy: {
      type: Boolean,
      default: false
    },
    // 是否移动
    isMove: {
      type: Boolean,
      default: false
    },
    // 是否添加
    isAdd: {
      type: Boolean,
      default: false
    },
    // 是否编辑
    isEdit: {
      type: Boolean,
      default: false
    },
    // 是否分页
    isPage: {
      type: Boolean,
      default: false
    },
    searchValue: {
      type: String,
      default: ''
    },
    tableHead: {
      type: Array
    },
    tableData: {
      type: Array
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          pageSize: 20,
          total: 20
        }
      }
    }
  },
  computed: {
    // 重新计算按钮个数
    getBtnsData: {
      get: function () {
        const btnsData = []
        if (this.isDelete)btnsData.push({ key: 'delete', value: '删除' })
        if (this.isCopy)btnsData.push({ key: 'copy', value: '复制' })
        if (this.isMove)btnsData.push({ key: 'move', value: '移动' })
        if (this.isEdit)btnsData.push({ key: 'edit', value: '编辑' })
        if (this.isAdd)btnsData.push({ key: 'add', value: '新增' })
        return btnsData
      },
      set: function () {
        console.log('setter')
      }
    },
    // 从新计算表格数据
    getNewTableData () {
      const data = this.newTableData
      if (this.isOrder) {
        data.map((v, i) => {
          v.orderNumberUp = i + 1
        })
      }
      return data
    }
  },
  watch: {
    isLoading (vl) { this.newIsLoading = vl },
    newIsLoading (vl) { this.$emit('update:isLoading', vl) },
    searchValue (vl) { this.newSearchValue = vl },
    newSearchValue (vl) { this.$emit('update:searchValue', vl) },
    tableHead (vl) { this.newTableHead = vl },
    newTableHead (vl) { this.$emit('update:tableHead', vl) },
    tableData (vl) { this.newTableData = vl },
    newTableData (vl) { this.$emit('update:tableData', vl) },
    pagination (vl) { this.newPagination = vl },
    newPagination (vl) { this.$emit('update:pagination', vl) }
  },
  data () {
    return {
      currentItem: null, // 当前正在编辑的行数据
      newIsLoading: this.isLoading,
      newSearchValue: this.searchValue,
      newTableHead: this.newTableHead,
      newTableData: this.tableData,
      newPagination: this.pagination
    }
  },
  methods: {
    rowClick (row) {
      this.$emit('onRowClick', row)
    },
    cellMouseEnter (row) {
      this.currentItem = row
      // console.log('rowMouseEnter==>', row)
    },
    onSearch (value) {
      console.log('onSearch==>', value)
      this.$emit('onSearch', value)
    },
    onBtns (item, data) {
      const newData = this.currentItem || data
      console.log('btns==>', item, newData)
      this.$emit('onBtns', item, newData)
    },
    handleSelectionChange (value) {
      console.log('handleSelectionChange', value)
    },
    currentChange (page) {
      this.$emit('currentChange', page)
      console.log('currentChange', page)
    }
  }
}
</script>

<style lang="scss" scoped>
  .container-table{
    padding: 30px 40px;
    width: calc(100% - 80px);
    max-height: calc(100vh - 120px);
    overflow-y: auto;

    .btn-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;

      .table-title{
        font-size: 14px;
        color: #323232;
        margin-right: 8px;

        &:nth-child(2){
          color: #909399;
        }
      }
    }
    .pages{
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 20px 0px;
    }
    .el-dropdown-link{
      cursor: pointer;
    }
  }
</style>
